export default {"src":"/_next/static/media/liberty-logo-with-text.9c06ef79.svg","height":40,"width":167};